export default __webpack_public_path__ + "static/media/BlindIcon.ee85c370.svg";